<div class="gp-card-shell personal-info-card">
  <div class="gp-card-header">
    <div class="gp-card-icon"><i class="pi pi-user"></i></div>
    <div class="gp-card-title-wrap">
      <h3 class="gp-card-title">Personal information</h3>
      <p class="gp-card-subtitle">Visible on your applicant profile</p>
    </div>
    <button class="edit-btn" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">
      <i class="pi pi-pencil"></i>
      <span>Edit</span>
    </button>
  </div>

  <form [formGroup]="basicInfoForm" (ngSubmit)="onSubmit()" class="info-form">

    <!-- Email (read-only) -->
    <div class="form-section">
      <div class="form-field">
        <label>Email <span class="cannot-change">&mdash; cannot be changed</span></label>
        <div class="email-field-shell">{{ userEmail }}</div>
        <div class="verified-badge">
          <i class="pi pi-check"></i> Verified
        </div>
      </div>
    </div>

    <!-- First & Last Name -->
    <div class="form-section">
      <div class="form-row two-col">
        <div class="form-field">
          <label>First name</label>
          <input type="text" formControlName="firstName" class="form-input" />
        </div>
        <div class="form-field">
          <label>Last name</label>
          <input type="text" formControlName="lastName" class="form-input" />
        </div>
      </div>

      <!-- Gender & DOB -->
      <div class="form-row two-col">
        <div class="form-field">
          <label>Gender</label>
          <p-dropdown formControlName="gender" [options]="genders" optionLabel="name" optionValue="value"
            placeholder="Select gender" [showClear]="true"></p-dropdown>
        </div>
        <div class="form-field">
          <label>Date of birth</label>
          <p-calendar formControlName="bornOn" [showIcon]="true" placeholder="MM / DD / YYYY"
            dateFormat="mm / dd / yy"></p-calendar>
        </div>
      </div>

      <!-- Current Location & Home Country -->
      <div class="form-row two-col">
        <div class="form-field">
          <label>Current Location</label>
          <p-dropdown formControlName="homeCountry" [options]="countries" optionLabel="name" optionValue="name"
            placeholder="Select country" [filter]="true"></p-dropdown>
        </div>
        <div class="form-field">
          <label>Home country</label>
          <p-dropdown formControlName="homeCountry" [options]="countries" optionLabel="name" optionValue="name"
            placeholder="Select country" [filter]="true"></p-dropdown>
        </div>
      </div>
    </div>

    <!-- Intended Countries (multi-select pill chips) -->
    <div class="form-section">
      <div class="form-field">
        <label>Intended Countries</label>

        <!-- Chip pills row (view + edit mode) -->
        <div class="country-chips-wrap">
          <!-- Selected chips with × -->
          <span *ngFor="let c of selectedDestinations" class="country-chip selected">
            {{ c }}
            <button type="button" class="chip-remove" (click)="removeDestination(c)" [disabled]="!isEditMode">
              <i class="pi pi-times"></i>
            </button>
          </span>

          <!-- Dropdown trigger for adding more (edit mode only) -->
          <div class="chip-add-wrap" *ngIf="isEditMode">
            <p-multiSelect formControlName="destination" [options]="countries" optionLabel="name" optionValue="name"
              placeholder="+ Add country" [showHeader]="true" [filter]="true" styleClass="chip-multiselect">
            </p-multiSelect>
          </div>
        </div>
      </div>
    </div>

    <!-- Degree & Term & Additional Info -->
    <div class="form-section">
      <div class="form-row two-col">
        <div class="form-field">
          <label>Intended Level</label>
          <p-dropdown formControlName="degreePreference" [options]="degreePrefs" optionLabel="name" optionValue="key"
            placeholder="Select Level"></p-dropdown>
        </div>
        <div class="form-field">
          <label>Field of Interest</label>
          <p-dropdown formControlName="fieldOfInterest" [options]="fieldOfInterestOptions" optionLabel="name"
            optionValue="key" placeholder="Select Fields"></p-dropdown>
        </div>
      </div>
      <div class="form-row two-col">
        <div class="form-field">
          <label>Choose where you are in this journey</label>
          <p-dropdown formControlName="journeyStatus" [options]="journeyStatusOptions" optionLabel="name"
            optionValue="key" placeholder="Select Level" appendTo="body"></p-dropdown>
        </div>
        <div class="form-field">
          <label>Enrollment Year</label>
          <p-dropdown formControlName="collageStartOn" [options]="collageStartOnTimings" optionLabel="name"
            optionValue="key" placeholder="Spring 2028" appendTo="body"></p-dropdown>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <button type="button" class="cancel-btn" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
      <button type="submit" class="submit-btn" [disabled]="loading">
        {{ loading ? 'Saving...' : 'Save changes' }}
      </button>
    </div>
  </form>
</div>